import React from "react";
import LastIntersectedElement from "components/admin/settings/LastIntersectedElement";
import TrendItem from "./TrendItem";

const TrendList = ({
  storyQuestions,
  lazyContainerRef,
  isProfile,
  onNextPage
}) => (
  <div className="trend-list">
    {storyQuestions.map(storyQuestion => (
      <TrendItem storyQuestion={storyQuestion} isProfile={isProfile} />
    ))}
    {!!storyQuestions.length && (
      <LastIntersectedElement
        rootRef={lazyContainerRef}
        onNearScreen={onNextPage}
      />
    )}
  </div>
);

export default TrendList;
